import { render, staticRenderFns } from "./TaskDesk.vue?vue&type=template&id=415cf823&scoped=true&"
import script from "./TaskDesk.vue?vue&type=script&lang=js&"
export * from "./TaskDesk.vue?vue&type=script&lang=js&"
import style0 from "./TaskDesk.vue?vue&type=style&index=0&id=415cf823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415cf823",
  null
  
)

export default component.exports